import { useCallback } from "react";

export const useSuggestions = (props) => {
  const { displayResult, filters, items, setVisible, visible } = props;

  const onNavigate = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  const shouldRender = !!(
    visible &&
    displayResult &&
    filters &&
    items &&
    items.length
  );

  return {
    onNavigate,
    shouldRender,
  };
};
